import {Component} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import {isNil} from 'lodash';
import {combineLatest} from 'rxjs';
import {BackofficePortfolioAllocation} from 'src/app/domain/model/backoffice-portfolio-allocation.model';
import {BackofficePortfolio} from 'src/app/domain/model/backoffice-portfolio/backoffice-portfolio.model';
import {CustomerPortfolioAllocation} from 'src/app/domain/model/customer-portfolio-allocation.model';
import CustomerPortfolioApi from 'src/app/domain/service/api/customer-portfolio.api';
import {AppEnvironmentService} from 'src/app/infrastructure/environment/app-environment/app-environment.service';
import {Router} from 'src/app/infrastructure/router/router';
import {OnboardingPortfolioService} from 'src/app/infrastructure/service/contracting/shared/portfolio/onboarding-portfolio.service';
import {WebPage} from 'src/app/ui/webapp/page/web.page';

@Component({
  selector: 'app-onboarding-editable-summary-allocation-details',
  templateUrl: 'oboarding-allocation-details-page.component.html'
})

export class OnboardingAllocationDetailsPage extends WebPage {
  recommendedPortfolio: BackofficePortfolio;
  allocationSlug: string;
  allocation: BackofficePortfolioAllocation | CustomerPortfolioAllocation;

  constructor(
    router: Router,
    private route: ActivatedRoute,
    private readonly portfolioApi: CustomerPortfolioApi,
    private readonly recommendedPortfolioService: OnboardingPortfolioService,
    appEnvironment: AppEnvironmentService,
    titleService: Title
  ) {
    super(router, appEnvironment, titleService);
  }

  public getAllocations(): BackofficePortfolioAllocation[] {
    return this.recommendedPortfolio?.allocations;
  }

  public allocationDataIsLoaded(): boolean {
    return !isNil(this.allocation);
  }

  protected onInit(): void {
    this.subscribe(combineLatest([this.route.params, this.recommendedPortfolioService.recommendedBoPortfolio$()]),
      ([params, recommendedPortfolio]) => {
        if (isNil(recommendedPortfolio) || isNil(params)) {
          return;
        }

        this.recommendedPortfolio = recommendedPortfolio;
        this.allocationSlug = params.slug;

        this.findAndSetAllocation(this.recommendedPortfolio.allocations);
      }
    );
  }

  private findAndSetAllocation(allocations: BackofficePortfolioAllocation[]): void {
    this.allocation = allocations.find((allocation) => allocation.security.slug === this.allocationSlug);
  }
}
